export default {
  mobile: 1023,
  mobileAppPadding: 25,
  desktopAppPadding: 85,
  headerHeight: {
    desktop: 90,
    mobile: 60,
  },
  footerHeight: {
    desktop: 180,
    mobile: 0,
  },
};
